<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input clearable style="width: 350px;" class="filter-item" placeholder="线索车型"
        v-model="listQuery.clueSeries"></el-input>
      <el-select style="width: 200px" class="filter-item" clearable v-model="listQuery.systemSeries" placeholder="系统车系">
        <el-option v-for="item in systemSeries" :key="item.name" :label="item.name" :value="item.name"></el-option>
      </el-select>
      <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">搜索</el-button>
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">重置</el-button>
      <el-button class="filter-item" type="primary" icon="el-icon-plus" @click="showImportDialog">导入</el-button>
      <el-button class="filter-item" icon="el-icon-download" @click="doExport">导出</el-button>
    </div>
    <el-table :data="list" v-loading="listLoading" fit border highlight-current-row style="width: 100%" max-height="550">
      <el-table-column align="left" label="日期" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="线索车型" min-width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="系统车系" min-width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.seriesName }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="操作" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="toEdit(scope.row)">编辑</el-button>
          <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog title="导入" :visible.sync="importDialogVisible" width="30%">
      <div style="text-align:center;">
        <el-upload class="upload-demo" accept=".xlsx" drag action :file-list="uploadFiles" :http-request="uploadRequest"
          :limit="1" :on-success="uploadSuccess" :on-remove="uploadRemove" :before-upload="uploadBefore">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a href="https://zhizhu-high.oss-cn-shenzhen.aliyuncs.com/zhizhu/template/%E7%BA%BF%E7%B4%A2%E8%BD%A6%E5%9E%8B%E6%98%A0%E5%B0%84%E6%A8%A1%E7%89%88.xlsx"
            class="table-href">下载模版</a>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog">取消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="doImport">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="600px">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-position="right" label-width="120px">
        <el-form-item label="线索车型" prop="name">
          <el-input style="width: 350px" v-model="editForm.name" placeholder="线索车型"></el-input>
        </el-form-item>
        <el-form-item label="系统车系" prop="seriesId">
          <el-select style="width: 200px" class="filter-item" v-model="editForm.seriesId" placeholder="系统车系">
            <el-option v-for="item in systemSeries" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import oss from "@/utils/ali-oss";

export default {
  name: 'OnlineSpecMapping',
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        clueSeries: '',
        systemSeries: ''
      },
      roles: [],

      importDialogVisible: false,
      uploadFiles: [],
      uploadFile: '',
      uploadLoading: false,
      systemSeries: [],
      editForm: {
        id: '',
        name: '',
        seriesId: ''
      },
      editFormRules: {
        seriesId: [
          {
            required: true,
            message: '请选择系统车系',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入线索车型',
            trigger: 'blur'
          }
        ]
      },
      editDialogVisible: false
    }
  },
  filters: {},
  beforeRouteEnter(to, from, next) {
    next()
  },
  activated() {
    if (
      this.$route.meta.hasOwnProperty('redraw') &&
      this.$route.meta.redraw
    ) {
      this.doReset()
      this.$route.meta.redraw = false
    }
    if (
      this.$route.meta.hasOwnProperty('refresh') &&
      this.$route.meta.refresh
    ) {
      this.getList()
      this.$route.meta.refresh = false
    }
  },
  created() {
    this.doReset()
    this.getSystemSeries()
  },
  methods: {
    getSystemSeries() {
      var parent = this
      this.$httpAuth
        .post('/v1/backendVehicleRpc/seriesList', {
          pageStart: 0,
          pageCount: 99,
          status: 99,
          name: '',
          code: '',
          isPreSale: 99,
          category: 99,
          needReport: 99
          // useMap: true
        })
        .then(function (response) {
          parent.systemSeries = response.data.data
        })
    },
    doReset() {
      this.list = null
      this.total = 0
      this.listLoading = true
      this.listQuery = {
        page: 1,
        limit: 10,
        clueSeries: '',
        systemSeries: '',
        title: '',
        content: ''
      }
      this.doSearch()
    },
    doSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.listLoading = true
      var parent = this
      this.$httpAuth
        .post('/v1/backendOnlineVehicleMapRpc/list', {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          clueSeries: this.listQuery.clueSeries,
          systemSeries: String(this.listQuery.systemSeries)
        })
        .then(function (response) {
          parent.listLoading = false
          parent.list = response.data.data
          parent.total = response.data.total
        })
        .catch(() => {
          parent.listLoading = false
        })
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    toDelete(id) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var parent = this
        this.$httpAuth
          .post('/v1/backendOnlineVehicleMapRpc/delete', {
            id: id
          })
          .then(function (response) {
            parent.$message({
              message: '删除成功',
              type: 'success'
            })
            parent.getList()
          })
      })
    },
    toEdit(item) {
      this.editForm.id = item.id
      this.editForm.name = item.name
      this.editForm.seriesId = item.seriesId
      this.editDialogVisible = true
    },
    doUpdate() {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          var parent = this
          this.$httpAuth
            .post('/v1/backendOnlineVehicleMapRpc/update', {
              id: parent.editForm.id,
              name: parent.editForm.name,
              seriesId: parent.editForm.seriesId
            })
            .then(function (response) {
              parent.$message({
                message: '编辑成功',
                type: 'success'
              })
              parent.editDialogVisible = false
              parent.getList()
            })
        }
      })
    },
    showImportDialog() {
      this.importDialogVisible = true
      this.uploadLoading = false
    },

    hideImportDialog() {
      this.uploadFiles = []
      this.uploadFile = ''
      this.importSource = ''
      this.importDialogVisible = false
    },

    uploadBefore(file) {
      if (file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error('请上传xlsx格式文件!')
        return false;
      }
    },
    uploadRequest(option) {
      oss.ossUploadFile(option)
    },
    uploadSuccess(res, file) {
      this.uploadFile = res;
    },

    uploadRemove(file, fileList) {
      this.uploadFile = ''
    },

    doImport() {
      if (this.uploadFile === '') {
        this.$message({
          message: '请选择导入文件',
          type: 'warning'
        })
        return
      }
      var parent = this
      parent.uploadLoading = true
      this.$httpAuth
        .post('/v1/backendOnlineVehicleMapRpc/import', {
          fileUrl: this.uploadFile
        })
        .then(function (response) {
          parent.uploadLoading = false
          console.log(response.data)
          parent.$notify({
            title: '导入结果',
            dangerouslyUseHTMLString: true,
            message:
              '<strong>插入 <i>' +
              response.data.addedCount +
              '</i> 条数据</strong>' +
              '<br>' +
              '<strong>更新 <i>' +
              response.data.updatedCount +
              '</i> 条数据</strong>' +
              '<br>' +
              '<strong>失败 <i>' +
              response.data.failedCount +
              '</i> 条数据</strong>'
          })
          parent.hideImportDialog()
          parent.doReset()
        })
        .catch(() => {
          parent.uploadLoading = false
          return
        })
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.$httpAuth
        .post('/v1/backendOnlineVehicleMapRpc/export', {
          clueSeries: this.listQuery.clueSeries,
          systemSeries: String(this.listQuery.systemSeries)
        })
        .then(function (response) {
          console.log(response.data)
          setTimeout(() => {
            loading.close()
            var a = document.createElement('a')
            a.href = response.data.file
            a.click()
          }, 1000)
        })
        .catch(() => {
          loading.close()
        })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
